export default function TextBoxJ ({title, placeholder, height}){
    let mt;
    height === 1 ? mt = '1rem' : mt='4rem';
    return(
        <label className="grid text-[26px] font-montserrat font-light" style={{marginTop: mt}}>
                    {title && <p className="pl-3 mb-3">{title}</p>}
                    <textarea wrap="soft" placeholder={placeholder} rows={height} cols={30} className=" rounded"></textarea>
        </label>
    )
}